(function ($) {
	if (jQuery().slick) {

		var dots = '.slick-dots button',
			dotsContainer = '.slick-dots',
			slideContainer = '.slick-track',
			slide = '.slick-slide',
			$homeCarousel = $('.home-news-carousel').slick({
				focusOnChange: false,
				accessibility: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				dots: true,
				autoplay: true,
				autoplaySpeed: 7000
			});

		$('.home-news-carousel .slick-dots').before('<button class="slick-play-pause icon-button icon-pause"><div class="visually-hidden">Stop automatic slide show</div></button>');

		$('.slick-play-pause').on('click', function () {

			if ($(this).hasClass('icon-play')) {
				$('.home-news-carousel').slick('slickPlay');
			} else {
				$('.home-news-carousel').slick('slickPause');
			}
			$(this).toggleClass('icon-play');
			$(this).toggleClass('icon-pause');
			if ($(this).hasClass('icon-play')) {
				$(this).html('<div class="visually-hidden">Start automatic slide show</div>');
			} else {
				$(this).html('<div class="visually-hidden">Stop automatic slide show</div>');
			}
		});

		// redirect focus to slides after clicking on the dots buttons 
		$(dots).each(function () {

			var $this = $(this);

			// redirect focus to read the content within the matched slide 
			$this.on('click', function (e) {

				var thisId = $this.attr('id'),
					matchedSlide = '[aria-describedby="' + thisId + '"]',
					$matchedSlideLink = $(matchedSlide).find('.home-news-link');


				setTimeout(function () {
					$matchedSlideLink.attr('tabindex', '-1').trigger('focus');
					$this.attr('aria-selected', 'true');
				}, 700);

				// prevent default click behavior
				e.preventDefault();

			});
		});

		var setAriaAttributes = function () {

			$(slideContainer).attr('role', 'region');
			$(slideContainer).attr('aria-roledescription', 'carousel');
			$(slideContainer).attr('aria-label', 'latest news');
			$(dotsContainer).attr('aria-label', 'slides');
			$(slide).attr('aria-roledescription', 'slide');


			$(dots).each(function () {

				var $this = $(this),
					thisText = $this.text(),
					newAriaLabel = 'Slide ' + thisText;

				$this.attr('aria-label', newAriaLabel);
				var selectedDot = $this.parent().hasClass('slick-active');
				if (selectedDot) {
					$this.attr('aria-selected', 'true');
				} else {
					$this.attr('aria-selected', 'false');
				}

			});
		};

		// set attributes on load
		setAriaAttributes();

		// set attribute on change slide
		$homeCarousel.on('afterChange', function () {
			setTimeout(function () {
				setAriaAttributes();
			}, 100);

		});
	}

})(jQuery);